import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from "src/environments/environment";
import { Observable } from 'rxjs';
import { RestClientService } from 'src/app/core/services/rest/rest-client.service';


@Injectable({
    providedIn: 'root'
})
export class ReportingProfilService{

    constructor(
        private http: HttpClient, 
        private _restClientService : RestClientService
        ) 
    {}
    
    exportQuantiteDossiersByEmployee(debut: String, fin: String, profil: String): Observable<Blob> {
        
        const downloadUrl = environment.BACKEND_RACINE_URL+'reporting-profil/export-quantite-dossier-by-employee?debut='+debut+'&fin='+fin+'&profile='+profil;
  
        const options = {
          responseType: 'blob' as 'json',
        };
        
        return this.http.get<any>(downloadUrl, options);
    }
  
    exportDossiersRecuByEmployee(debut: String, fin: String, profil: String): Observable<Blob> {
        
        const downloadUrl = environment.BACKEND_RACINE_URL+'reporting-profil/export-dossier-recu-by-employee?debut='+debut+'&fin='+fin+'&profile='+profil;
  
        const options = {
          responseType: 'blob' as 'json',
        };
        
        return this.http.get<any>(downloadUrl, options);
    }
  
    exportDossiersValideByEmployee(debut: String, fin: String, profil: String): Observable<Blob> {
        
        const downloadUrl = environment.BACKEND_RACINE_URL+'reporting-profil/export-dossier-valide-by-employee?debut='+debut+'&fin='+fin+'&profile='+profil;
  
        const options = {
          responseType: 'blob' as 'json',
        };
        
        return this.http.get<any>(downloadUrl, options);
    }
  
    exportDossiersEncoursByEmployee(debut: String, fin: String, profil: String): Observable<Blob> {
        
        const downloadUrl = environment.BACKEND_RACINE_URL+'reporting-profil/export-dossier-en-cours-by-employee?debut='+debut+'&fin='+fin+'&profile='+profil;
  
        const options = {
          responseType: 'blob' as 'json',
        };
        
        return this.http.get<any>(downloadUrl, options);
    }
  
    exportDossiersAcorrigerByEmployee(debut: String, fin: String, profil: String): Observable<Blob> {
        
        const downloadUrl = environment.BACKEND_RACINE_URL+'reporting-profil/export-dossier-a-corriger-by-employee?debut='+debut+'&fin='+fin+'&profile='+profil;
  
        const options = {
          responseType: 'blob' as 'json',
        };
        
        return this.http.get<any>(downloadUrl, options);
    }
  
      
  
}